import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
  schema?: any;
}

const SEO: React.FC<SEOProps> = ({
  title = 'VitalBalanceHormones | Bioidentical Hormone Therapy',
  description = 'Restore hormonal balance and reclaim your vitality with personalized bioidentical hormone therapy. Expert care for women experiencing menopause, perimenopause, and hormonal imbalances.',
  keywords = 'bioidentical hormone therapy, hormone replacement, women\'s health, menopause treatment',
  image = '/logo512.png',
  url,
  type = 'website',
  schema,
}) => {
  // Calculate the canonical URL
  const currentUrl = url || typeof window !== 'undefined' ? window.location.pathname : '';
  const canonicalUrl = `https://vitalbalancehormones.com${currentUrl}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`https://vitalbalancehormones.com${image}`} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={`https://vitalbalancehormones.com${image}`} />

      {/* JSON-LD Schema Markup */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;